import * as React from 'react';
import { IDataEntity, IDataEntityResponse, IDataTimeseries } from '../../models';
import { safe, toDisplay, getGroupedRows } from "../../utils";
import * as moment from "moment";
import { NumberFormat } from "../../assets/NumberFormat/NumberFormat";
import { IPageProperties, IExplorerProperties } from "../../models";
import { ArrowIndicator, Disclaimer } from "../../assets";
import { ExplorerTabDailyPrices, ExplorerTabPerformance, ExplorerTabCharges, ExplorerTabYield } from "../FundExplorerTabs";
const FaAngleDown = require('react-icons/lib/fa/angle-down');
const styles = require('../FundPages/Fundpages.pcss');
const internalStyles = require('./DistributionRatesPDF.pcss');
const FaPDF = require('react-icons/lib/fa/file-pdf-o');
const FaDownload = require('react-icons/lib/fa/download');

interface IState {
	visible: boolean;
}

export class DistributionRatesPDF extends React.Component<IExplorerProperties, IState> {
	constructor(props) {
		super(props);
	}

	getRows(shareClass) {
		let { appParams } = this.props;

		let { startdate, enddate, sort } = appParams;
		let rows = [];
		let distributionRates = shareClass.timeseries ? shareClass.timeseries.filter((item: IDataTimeseries) => item.code === "distribution_rates")[0] : { values: [] };

		for (let values of distributionRates.values) {
			if (moment(values.date).isBetween(startdate, enddate, null, '[]')) {
				rows.push([
					shareClass.properties["fund_name"],
					shareClass.properties.shareclass_name,
					shareClass.clientCode,
					moment(values["xd_date"]).format("DD.MM.YYYY"),
					moment(values["date"]).format("DD.MM.YYYY"),
					values["payment_type"],
					parseFloat(values["value"].toFixed(4))
				]);
			}
		}

		if (sort === 'DESC') {
			rows.reverse();
		}
		return rows;
	}

	render() {
		let { funds, shareClass: shareClassData, disclaimers, appParams } = this.props;
		let rows = [];
		const shareClass = shareClassData && shareClassData.values ? shareClassData.values[0] : null;
		const distributionRates = shareClass && shareClass.timeseries ? shareClass.timeseries.filter((item: IDataTimeseries) => item.code === "distribution_rates") : [];

		if (shareClass && distributionRates) {
			rows = [...this.getRows(shareClass)];
			if (shareClass) {
				setTimeout(() => {
					window.status = "pdfdataloaded"; //wkhtmltopdf
					global['docdone'] = true; //electron using exportPdf endpoint of FundPress
				}, 1000);
			}
			return (
				<div className={internalStyles.printable}>
					<div className={internalStyles.tableElement}>
						<table>
							<thead>
								<tr className={internalStyles.hackHeader}>
									<th colSpan={rows.length > 0 ? rows[0].length : 1}>
										<div className={internalStyles.headerRow}>
											<div className={internalStyles.logoHolder}>
												<img style={{ width: 'auto', height: '100px' }} src={require('../../images/Investments-logo.svg')} />
											</div>
											<div className={internalStyles.PageTitle}>
												<h1>Distribution Rates</h1>
											</div>
										</div>
									</th>
								</tr>
								<tr className={styles.RowItems + ' ' + internalStyles.tableRow}>
									<th>Fund Name</th>
									<th className={internalStyles.center}>Share Class</th>
									<th className={internalStyles.center}>ISIN</th>
									<th className={internalStyles.center}>XD Date</th>
									<th className={internalStyles.center}>Payment Date</th>
									<th className={internalStyles.center}>Payment Type</th>
									<th className={internalStyles.numberColumn}>Income {this.getIncomeTypeFormatted(distributionRates, shareClass)}</th>
								</tr>
							</thead>
							<tbody>
								{rows.map((row, index) => {
									return (
										<tr key={index} className={styles.RowItems + ' ' + internalStyles.tableRow}>
											{row.map((item, i) => {
												return (<td key={i} className={typeof item === 'number' ? internalStyles.numberColumn : internalStyles.center}>{item}</td>)
											})}
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
					<Disclaimer appParams={appParams} disclaimer={disclaimers["daily_prices_disclaimer"]} />
				</div>
			);
		} else {
			return null;
		}
	}

	private getIncomeTypeFormatted = (distributionRates: IDataTimeseries[], shareClass: IDataEntity): string => {
		const currency = shareClass && shareClass.properties && shareClass.properties.currency && shareClass.properties.currency.trim() !== '' ? shareClass.properties.currency : 'GBP';
		if (distributionRates.length > 0 && distributionRates[0].values.length > 0) {
			return distributionRates[0].values[0]["income_type"] === "" ? `(${currency})` : `(${distributionRates[0].values[0]["income_type"]} ${currency})`;
		}
		return `(${currency})`;
	}
}







// WEBPACK FOOTER //
// ./src/client/components/DistributionRatesPDF/DistributionRatesPDF.tsx